/**
 * @class Ease
 */
function Ease(){
}

/**
 * Ease out quart
 * @param {number} progress 0 to 1
 * @param {number} from From value
 * @param {number} to To/Final value
 * @returns {number}
 */
Ease.outQuart = function outQuart(progress, from, to) {
	return from + (from - to) * (Math.pow(progress - 1, 4) - 1);
};